import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Badge } from '@/components/ui/badge';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' }) : '');

// Day 22 — lifecycle timeline + version chain (variation / superseded) for the agreement details dialog.
export function AgreementHistoryPanel({ agreement }) {
  const [versions, setVersions] = useState([]);
  useEffect(() => {
    if (!agreement?.id) return;
    api.get(`/agreements/${agreement.id}/versions`).then((r) => setVersions(r.data?.data || [])).catch(() => setVersions([]));
  }, [agreement?.id]);
  const history = [...(agreement?.lifecycle_history || [])].reverse();
  return (
    <div className="space-y-3" data-testid="agreement-history-panel">
      {versions.length > 1 && (
        <div>
          <p className="text-muted-foreground mb-1 text-xs uppercase tracking-wide">Versions</p>
          <div className="space-y-1">
            {versions.map((v) => (
              <div key={v.id} className={`flex items-center justify-between rounded border px-2 py-1 text-xs ${v.id === agreement.id ? 'border-primary/50 bg-primary/5' : ''}`} data-testid={`agreement-version-${v.version_no}`}>
                <span>v{v.version_no} · {v.agreement_no} · {v.start_date} → {v.end_date}</span>
                <Badge variant="outline" className="text-[10px]">{v.effective_status || v.status}</Badge>
              </div>
            ))}
          </div>
        </div>
      )}
      <div>
        <p className="text-muted-foreground mb-1 text-xs uppercase tracking-wide">Lifecycle history</p>
        {history.length === 0 ? <p className="text-xs text-muted-foreground">No lifecycle events recorded.</p> : (
          <ol className="relative border-l pl-3 space-y-1.5">
            {history.map((h, i) => (
              <li key={i} className="text-xs" data-testid={`agreement-history-${i}`}>
                <span className="absolute -left-[5px] mt-1 h-2 w-2 rounded-full bg-primary" />
                <span className="font-medium">{String(h.action || '').replace(/_/g, ' ')}</span>
                {h.to && <span className="text-muted-foreground"> → {h.to}</span>}
                <span className="text-muted-foreground"> · {fmt(h.at)}</span>
                {h.reason && <div className="text-muted-foreground italic">“{h.reason}”</div>}
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}

export default AgreementHistoryPanel;
